/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} White_Fair_Mayfly_RenewInputs */

const fr_white_fair_mayfly_renew = /** @type {(inputs: White_Fair_Mayfly_RenewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historique de tes séances`)
};

/**

* @param {White_Fair_Mayfly_RenewInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const white_fair_mayfly_renew = /** @type {((inputs?: White_Fair_Mayfly_RenewInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<White_Fair_Mayfly_RenewInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_white_fair_mayfly_renew(inputs)
});